import { render, staticRenderFns } from "./SecurityTabRoles.vue?vue&type=template&id=85065d4c"
import script from "./SecurityTabRoles.vue?vue&type=script&lang=js"
export * from "./SecurityTabRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports